import handleUpdatePostSubmitQuestionnaire from "../handleUpdatePostSubmitQuestionnaire";
import useFeatureState from "./useFeatureState";
import useUpdateUserProfileMutation from "./useUpdateUserProfileMutation";

const useUpdatePostSubmitQuestionnaire = callback => {
  const [updateUserProfile] = useUpdateUserProfileMutation();
  const { postSubmitAnswers: formData } = useFeatureState();

  return handleUpdatePostSubmitQuestionnaire({
    callback,
    formData,
    updateUserProfile
  });
};

export default useUpdatePostSubmitQuestionnaire;
